import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addToHistory } from 'store/navigation';

const NavigationTracker = (): null => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addToHistory(location.pathname));
  }, [location.pathname, dispatch]);

  return null;
};

export default NavigationTracker;
